import { scriptitemService } from '../../services'

// initial state
const state = () => ({
  scriptItems: [],
  scriptItem: null
})

// actions
const actions = {
  getScriptItems({ commit, rootState }, eventId) {
    if (!eventId) {
      eventId = rootState.event?.activeEvent?.id
    }
    scriptitemService.getScriptItems(eventId).then(
      (scriptItems) => {
        commit('getScriptItemsSuccess', scriptItems)
      },
      (error) => {
        commit('getScriptItemsFailure', error)
      }
    )
  },
  getScriptItem({ commit }, itemId) {
    scriptitemService.getScriptItem(itemId).then(
      (scriptItem) => {
        commit('scriptItemSuccess', scriptItem)
      },
      (error) => {
        commit('scriptItemFailure', error)
      }
    )
  },
  createScriptItem({ commit, dispatch }, itemData) {
    scriptitemService.createScriptItem(itemData).then(
      (scriptItem) => {
        commit('scriptItemSuccess', scriptItem)
        dispatch('getScriptItems')
      },
      (error) => {
        commit('scriptItemFailure', error)
      }
    )
  },
  updateScriptItem({ commit, dispatch }, { itemId, itemData }) {
    scriptitemService.updateScriptItem(itemId, itemData).then(
      (scriptItem) => {
        commit('scriptItemSuccess', scriptItem)
        dispatch('getScriptItems')
      },
      (error) => {
        commit('scriptItemFailure', error)
      }
    )
  },
  deleteScriptItem({ commit, dispatch }, itemId) {
    scriptitemService.deleteScriptItem(itemId).then(
      (scriptItem) => {
        commit('scriptItemSuccess', scriptItem)
        dispatch('getScriptItems')
      },
      (error) => {
        commit('scriptItemFailure', error)
      }
    )
  }
}

// mutations
const mutations = {
  getScriptItemsSuccess(state, items) {
    state.scriptItems = items
  },
  scriptItemSuccess(state, item) {
    state.scriptItem = item
  },
  getScriptItemsFailure(state, error) {
    console.log(state, error)
  },
  scriptItemFailure(state, error) {
    console.log(state, error)
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
